import { createContext, useContext } from 'react';

type MediaQueryState = {
  isScreenWiderThan480: boolean;
  isDesktopScreen: boolean;
};

export const MediaQueryContext = createContext<MediaQueryState>({
  isScreenWiderThan480: false,
  isDesktopScreen: true,
});

export const useMediaQueryContext = () => useContext(MediaQueryContext);
